import {ICellRendererParams} from 'ag-grid-community';
import * as React from 'react';

import {DateFormatter} from './DateFormatter';

type Props = ICellRendererParams;

export const DateTimeFormatter: React.FC<Props> = (props) => {
  return <DateFormatter dateOnly={false} {...props} />;
};

DateTimeFormatter.displayName = 'DateTimeFormatter';
